import { CarouselItemId } from '@homex/se-widget-flow-types';

import { CarouselItemAddressBottom } from 'components/CarouselItemAddressBottom';

export const CarouselItemAddressSalesBottom = () => {
  return (
    <CarouselItemAddressBottom
      correctionNeededDestinationId={CarouselItemId.SalesAddressCorrection}
      matchFoundDestinationId={CarouselItemId.ScheduleEmergency}
      matchNotFoundDestinationId={CarouselItemId.SalesAddressNotFound}
      parentCarouselItemId={CarouselItemId.SalesAddress}
    />
  );
};
